import { useMemo } from 'react'
import CellContent from './CellContent'
import BodyText from 'LuxKit/Typography/BodyText'
import { formatDynamicDateRange } from 'lib/datetime/dateUtils'

interface Props {
  filters: App.OfferListFilters
}

function LEHotelDateCell({ filters }: Props) {
  const checkIn = filters.checkIn
  const checkOut = filters.checkOut

  const formattedDateRange = useMemo(() => {
    if (checkIn && checkOut) {
      const dateRange = formatDynamicDateRange(checkIn, checkOut)
      if (!dateRange) return false
      return dateRange
    }
    return false
  }, [checkIn, checkOut])

  return (
    <CellContent>
      {/* We only want to show this column if the comparison is the same package */}
      {formattedDateRange && <BodyText variant="medium">{formattedDateRange}</BodyText>}
    </CellContent>
  )
}

export default LEHotelDateCell
